import { useEffect, useState } from "react";
import { ConnectionStatus } from "@2stand-events/chat-client";
import useClient from "./useClient";
export default function useConnectionStatus() {
    const [status, setStatus] = useState(ConnectionStatus.Disconnected);
    const client = useClient();
    useEffect(() => {
        const unsubscribe = client.on("all", () => setStatus(client.status));
        setStatus((client === null || client === void 0 ? void 0 : client.status) || ConnectionStatus.Disconnected);
        return unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe.unsubscribe;
    }, [client]);
    return status;
}
//# sourceMappingURL=useConnectionStatus.js.map